import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export const Logo = ({ linkTo }) => {
  return (
    <BrandName to={linkTo}>
      <img src={"/images/logo.png"} alt="Hexa" />
    </BrandName>
  );
};
const BrandName = styled(Link)`
  ${(props) => {
    let current = props.theme;
    return `
    font-weight: normal;
    line-height: 1;
    transition: 0.2s;
    ${current.fXXL};
    color: rgb(${current.white});
    ${current.primaryFont};
    margin-left: ${current.gLG};
    margin-right: ${current.gMD};
    > span {
      ${current.secondaryFont};
      display: block;
      ${current.fSM};
      transition: 0.2s;
    }
    >img{
      width:120px;
    }
  `;
  }}
`;
